module.exports = __webpack_public_path__ + "img/bg5.1071ceaa.png";